import React from "react";
import "./Navbar.css";
import Logo from "../../../assets/images/logo.png";
import RoundLogo from "../../../assets/images/admin-dashboard/round-logo.png";
import { NavLink } from "react-router-dom";
import Mobilebar from "./MobileBar";
const AdminNavbar = () => {
  return (
    <>
      <div className="admin__navbar_wrap">
        <div className="admin__navbar_left">
          <div className="admin__navbar_leftlogo">
            <img src={Logo} alt="" />{" "}
          </div>
          <div className="admin__navbar_leftitems">
            <NavLink
              className={({ isActive }) => {
                return `${
                  !isActive
                    ? "admin__navbar_leftitem"
                    : "admin__navbar_leftitem admin__navbar_leftitemactive"
                }`;
              }}
              to="/admin-dashboard/scheduling"
            >
              Schedule
            </NavLink>
            <NavLink
              className={({ isActive }) => {
                return `${
                  !isActive
                    ? "admin__navbar_leftitem"
                    : "admin__navbar_leftitem admin__navbar_leftitemactive"
                }`;
              }}
              to="/admin-dashboard/documents"
            >
              Documents
            </NavLink>
            <NavLink
              className={({ isActive }) => {
                return `${
                  !isActive
                    ? "admin__navbar_leftitem"
                    : "admin__navbar_leftitem admin__navbar_leftitemactive"
                }`;
              }}
              to="/admin-dashboard/tax-preparation"
            >
              Tax Preparation
            </NavLink>
            <NavLink
              className={({ isActive }) => {
                return `${
                  !isActive
                    ? "admin__navbar_leftitem"
                    : "admin__navbar_leftitem admin__navbar_leftitemactive"
                }`;
              }}
              to="/admin-dashboard/review"
            >
              Review
            </NavLink>
            <NavLink
              className={({ isActive }) => {
                return `${
                  !isActive
                    ? "admin__navbar_leftitem"
                    : "admin__navbar_leftitem admin__navbar_leftitemactive"
                }`;
              }}
              to="/admin-dashboard/payment"
            >
              Payment
            </NavLink>
            <NavLink
              className={({ isActive }) => {
                return `${
                  !isActive
                    ? "admin__navbar_leftitem"
                    : "admin__navbar_leftitem admin__navbar_leftitemactive"
                }`;
              }}
              to="/admin-dashboard/client-review"
            >
              Client Review
            </NavLink>
            <NavLink
              className={({ isActive }) => {
                return `${
                  !isActive
                    ? "admin__navbar_leftitem"
                    : "admin__navbar_leftitem admin__navbar_leftitemactive"
                }`;
              }}
              to="/admin-dashboard/e-filing"
            >
              E-Filing
            </NavLink>
          </div>
        </div>
        <div className="admin__navbar_right">
          <span className="admin__navbar_righttxt">Hi, Praveen!</span>
          <img src={RoundLogo} alt="" className="admin__navbar_rightlogo" />
        </div>
      </div>
      <Mobilebar />
    </>
  );
};

export default AdminNavbar;
